import { render, staticRenderFns } from "./PopularComponent.vue?vue&type=template&id=f3fbafec&scoped=true&"
import script from "./PopularComponent.vue?vue&type=script&lang=js&"
export * from "./PopularComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopularComponent.vue?vue&type=style&index=0&id=f3fbafec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fbafec",
  null
  
)

export default component.exports